module.exports = __webpack_public_path__ + "public/hws/images/loginimg_en-us.png";


//////////////////
// WEBPACK FOOTER
// ./public/hws/images/loginimg_en-us.png
// module id = 98
// module chunks = 0